import React from "react"
import {graphql, Link} from "gatsby"

import Layout from "../../components/Layout"
import * as caseStyles from "../../components/cases/cases.module.scss";
import BlogHero from "../../components/blog/BlogHero";
import BlogContent from "../../components/blog/BlogContent";
import Content from "../../components/content/Content";
import BgBanner from "../../components/content/BgBanner";
import ShareNav from "../../components/blog/ShareNav";
import * as styles from "../../components/content/content.module.scss";
import ContactMeForm from "../../components/forms/ContactMeForm";
import parse from "html-react-parser";
import marco from "../../images/marco.png";
import daan from "../../images/daan.png";

const BlogPostTemplate = ({data: {previous, next, post}}) => {


    const medewerkers = [
      {
        name: "Marco",
        image: marco,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="152.559" height="57.107" viewBox="0 0 152.559 57.107"><g transform="translate(-928.536 -783.042)" fill="#22252d"><path d="M1001.225,764.815c-12.929,1.63-22.243-4.959-26.213-17.22-1.894-5.849-2.3-12.481-2.43-18.583-.031-1.5-.028-3.065.057-4.649,3.045-3.957,4.957-8.675,4.374-13.767-.01-.08-.215-1.217-.443-.951-3.122,3.66-4.041,8.572-4.36,13.326a42.742,42.742,0,0,1-8.083,7.606c-5.51,4.093-13.445,8.083-18.555,1.341a17.136,17.136,0,0,1-2.74-7.183c-.036-.21-.043-.422-.074-.631a20.652,20.652,0,0,0-.251-7.926c-.049-.211-.394-.905-.443-.3a39.364,39.364,0,0,0,.174,7.65,29.614,29.614,0,0,1-3.885,9.142c-3.833,6.353-9.956,12.019-16.935,14.649-.389.146.018,1.709.257,1.619,9.423-3.55,18.639-13.152,20.835-23.6,1.169,6.556,4.4,12.719,11.727,11.861,6.025-.705,12.312-6.238,16.32-10.4q.8-.834,1.54-1.728c-.013.341-.03.687-.039,1.025a73.981,73.981,0,0,0,1.776,19c1.471,6.053,3.875,11.778,8.393,16.187,5.13,5.008,12.432,6.005,19.255,5.144C1001.808,766.394,1001.577,764.771,1001.225,764.815Zm-24.642-53.13a17.508,17.508,0,0,1-3.76,10.471A20.441,20.441,0,0,1,976.582,711.685Z" transform="translate(7.28 73.438)"/><path d="M998.465,723.046c-2.476-4.07-7.612-1.846-10.694.4a21.479,21.479,0,0,0-5.585,6.374c.569-2.4,1.015-4.813,1.358-7.145.048-.31-.385-1.863-.507-1.094-.874,5.461-2.811,11.745-8.132,14.367-5.4,2.662-8.062-1.445-9.026-6.04a37.66,37.66,0,0,1,11.391.408c.19.034.19-1.54-.257-1.619a37.462,37.462,0,0,0-11.4-.4,20.531,20.531,0,0,1-.11-4.257c.028-.313-.439-1.853-.507-1.094a8.841,8.841,0,0,1-3.974,6.407,18.688,18.688,0,0,0-6.345,3.618.479.479,0,0,0-.1.346c-.084.054-.172.107-.254.161-.4.262.133,1.7.256,1.62,2.174-1.43,4.488-2.619,6.622-4.106a23.624,23.624,0,0,1,3.89-.966c.356,2.548,1.171,5.007,2.9,6.55,4.657,4.151,10.367-.217,12.74-4.723-.125.443-.233.887-.367,1.327a76.047,76.047,0,0,0-2.909,7.261c-.113.32.32,1.63.411,1.451a45.972,45.972,0,0,0,3.073-7.566,28.159,28.159,0,0,1,5.293-7.822c2.745-2.722,9.441-6.578,12.215-2.02C998.662,724.825,998.657,723.361,998.465,723.046Zm-34.67,5.554a12.132,12.132,0,0,0,1.009-1.548c.021-.043.031-.075.051-.116.01.48.033.971.067,1.463C964.544,728.459,964.167,728.523,963.795,728.6Z" transform="translate(28.349 80.588)"/><path d="M1020.8,721.039c-.313.028-.113,1.651.256,1.62,8.793-.751,18.814,8.406,13.026,17.358-3.281,5.074-10.477,7.042-16.151,7.26-6.555.253-18.617-3.509-11.4-12.089a18.78,18.78,0,0,1,6.007-4.533c2.93-1.036,5.905-1.14,9.751-1.3.3-.011.1-1.507-.19-1.6-.021-.007-.044-.01-.066-.016v0h-.013a12.751,12.751,0,0,0-7.748.434c-.538.09-1.076.2-1.612.341-2.506.677-4.948,2.937-6.937,4.51-5.479,4.329-10.853,8.778-17.83,10.359-4.874,1.1-8.919-2.161-7.361-7.758.73-2.622,2.827-4.9,4.785-6.684,4.418-4.021,10.667-4.985,14.426.325.246.348.226-1.135.013-1.435-7.243-10.233-23.4,2.63-19.718,12.842,2.671,7.416,11.015,3.852,16.15,1.122a53.31,53.31,0,0,0,8.547-6.105,10.075,10.075,0,0,0-.946,2.27c-2.06,7.648,6.91,10.712,12.689,10.943,8.314.333,18.834-3.585,19.982-12.894C1037.5,727.571,1028.715,720.364,1020.8,721.039Z" transform="translate(44.55 80.726)"/></g></svg>'
      }
    ]
    const medewerker = medewerkers.sort(() => Math.random() - Math.random())
      .find(() => true);

    return (
        <Layout posttype={`blog`} seo={post.seo}>

            <BlogHero date={post.date} title={post.title} tags={post.tags.nodes}/>

            <BlogContent title={null} desc={post.content} image={post.featuredImage} cta={null}/>

            {post.imageBanner &&
            <BgBanner content={post.imageBanner}/>
            }

            {post.standaardContent.defaultContent &&
            post.standaardContent.defaultContent.map((defaultContent, key) => {
                return <Content key={key} content={defaultContent}/>
            })
            }

            <section className={styles.contentSection}>
              <div className="grid-container-wrap">
                <div className="grid-container">
                  <div className={styles.gridContactImgWrapper}>
                    <figure className={styles.gridContactImg}>
                      <img
                        alt={medewerker.name}
                        src={medewerker.image}
                        datatype="image/png"
                        placeholder="blurred"
                      />
                      <figcaption title={medewerker.name} className={styles.gridContactName}>
                        <span className="sr-only">{medewerker.name}</span>
                        {parse(medewerker.svg)}
                      </figcaption>
                    </figure>
                  </div>
                  <div className={styles.gridContact +' '+ styles.fontSizeSmall}>
                    <h2>Kennismaken?</h2>
                    <p>Vul je gegevens in, dan nemen wij nemen contact met je op!</p>
                    <ContactMeForm/>
                  </div>
                </div>
              </div>
            </section>

            <ShareNav/>

            <nav className={caseStyles.casesNav}>
                {previous ? (
                    <Link title={`Vorig bericht: ${previous.title}`} className={caseStyles.casesNavPrev}
                          to={previous.uri} rel="prev">
                        <span>Vorig bericht<span className="sr-only">: {previous.title}</span></span>
                    </Link>
                ) : (
                    <Link to={``} className={`${caseStyles.casesNavPrev} disabled`} rel="prev">
                        <span>Vorig bericht</span>
                    </Link>
                )
                }

                <Link title="Nieuws overzicht" className={caseStyles.casesNavOverview} to={`/blog/`}>
                    <span>Nieuws overzicht</span>
                </Link>

                {next ? (
                    <Link title={`Volgend bericht: ${next.title}`} className={caseStyles.casesNavNext} to={next.uri}
                          rel="next">
                        <span>Volgend bericht<span className="sr-only">: {next.title}</span></span>
                    </Link>
                ) : (
                    <Link to={``} className={`${caseStyles.casesNavNext} disabled`} rel="next">
                        <span>Volgend bericht</span>
                    </Link>
                )
                }
            </nav>
        </Layout>
    )
}

export default BlogPostTemplate

export const pageQuery = graphql`query BlogpostById($id: String!, $previousPostId: String, $nextPostId: String) {
  post: wpBlogpost(id: {eq: $id}) {
    id
    content
    title
    date(formatString: "DD MMMM YYYY", locale: "nl")
    uri
    tags {
      nodes {
        slug
        name
        id
      }
    }
    featuredImage {
      node {
        title
        altText
        localFile {
          childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 797, placeholder: BLURRED)
          }
        }
      }
    }
    seo {
      title
      metaDesc
      canonical
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphType
    }
    imageBanner {
      bannercta {
        target
        title
        url
      }
      bannerdescription
      bannerimage {
        title
        altText
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, width: 10, layout: FULL_WIDTH)
          }
        }
      }
    }
    standaardContent {
      defaultContent {
        contentCta {
          target
          url
          title
        }
        contentDescription
        contentTitle
        contentImage {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 797, placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
  previous: wpBlogpost(id: {eq: $previousPostId}) {
    uri
    title
  }
  next: wpBlogpost(id: {eq: $nextPostId}) {
    uri
    title
  }
}
`
